import { evaluatePassword, PASSWORD_RULES } from '../lib/password';

/** Medidor de fortaleza con las reglas siempre visibles. */
export function PasswordStrengthMeter({ value }: { value: string }): JSX.Element {
  const strength = evaluatePassword(value);

  return (
    <div className="strength">
      <div className="strength__bar" aria-hidden="true">
        {[1, 2, 3, 4].map((segment) => (
          <span
            key={segment}
            className="strength__seg"
            data-on={strength.level >= segment}
            data-level={strength.level}
          />
        ))}
      </div>
      <span className="strength__label" aria-live="polite">
        Fortaleza: {strength.label}
      </span>
      <ul className="rules">
        {PASSWORD_RULES.map((rule) => {
          const ok = strength.satisfied.includes(rule.id);
          return (
            <li key={rule.id} data-ok={ok}>
              <span className="rules__mark" aria-hidden="true">
                {ok ? '✓' : '·'}
              </span>
              {rule.label}
              <span className="sr-only">{ok ? ' (cumplido)' : ' (pendiente)'}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
